import type { ReactNode } from "react";
import "./ui.css";

interface SectionHeaderProps {
	title: string;
	actions?: ReactNode;
}

export function SectionHeader({ title, actions }: SectionHeaderProps) {
	return (
		<div className="ui-section-header">
			<h3 className="ui-section-header-title">{title}</h3>
			{actions && <div className="ui-section-header-actions">{actions}</div>}
		</div>
	);
}
